<div class="card">
  <h2 class="card-title">Recurring benefit payments</h2>

  <div class="card-body">
    <form [formGroup]="filters" class="toolbar" (ngSubmit)="load()">
      <label>
        Status
        <select formControlName="status">
          <option value="">All statuses</option>
          @for (status of statuses; track status) {
            <option [value]="status">{{ status }}</option>
          }
        </select>
      </label>

      <label>
        Scholarship
        <select formControlName="scholarshipId">
          <option [ngValue]="null">All scholarships</option>
          @for (scholarship of scholarships(); track scholarship.id) {
            <option [ngValue]="scholarship.id">{{ scholarship.title }}</option>
          }
        </select>
      </label>

      <label>
        Due on or before
        <input type="date" formControlName="dueBefore" />
      </label>

      <label>
        Search
        <input type="text" formControlName="search" placeholder="Reference, student or payee" />
      </label>

      <div class="toolbar-actions">
        <button type="submit" class="btn btn-primary btn-sm"><i class="fas fa-search"></i> Filter</button>
      </div>
    </form>

    @if (error()) {
      <div class="alert alert-warning"><i class="fas fa-exclamation-circle"></i> {{ error() }}</div>
    }
    @if (message()) {
      <div class="alert alert-success"><i class="fas fa-check-circle"></i> {{ message() }}</div>
    }

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Reference</th>
            <th>Student</th>
            <th>Scholarship</th>
            <th>Benefit</th>
            <th>Payee</th>
            <th>Due</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="9" class="empty-cell"><i class="fas fa-spinner fa-spin"></i> Loading payments…</td></tr>
          }
          @if (!loading() && payments().length === 0) {
            <tr><td colspan="9" class="empty-cell">No scheduled payments match these filters.</td></tr>
          }
          @for (payment of payments(); track payment.id) {
            <tr>
              <td>{{ payment.referenceNumber }}</td>
              <td>{{ payment.student.fullName || '—' }}</td>
              <td>
                {{ payment.scholarshipTitle || '—' }}
                @if (payment.awardReferenceNumber) { <small>{{ payment.awardReferenceNumber }}</small> }
              </td>
              <td>{{ payment.benefitName }}</td>
              <td>{{ payment.payeeName || '—' }}</td>
              <td>{{ payment.dueDate | date: 'mediumDate' }}</td>
              <td>{{ payment.paidAmount ?? payment.amount | number: '1.2-2' }} {{ payment.currency }}</td>
              <td>
                <span [class]="statusClass(payment.status)">{{ payment.status }}</span>
                @if (payment.paidDate) { <small>Settled {{ payment.paidDate | date: 'mediumDate' }}</small> }
              </td>
              <td>
                @if (canSettle(payment)) {
                  <button type="button" class="btn btn-primary btn-sm" (click)="open(payment)"
                    [disabled]="!authorization.hasPermission(permissions.ClaimPay)">Settle</button>
                  @if (authorization.hasPermission(permissions.AwardManage)) {
                    <button type="button" class="btn btn-secondary btn-sm" (click)="cancel(payment)">Cancel</button>

@if (selected(); as payment) {
  <div class="modal-backdrop" (click)="close()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Payment {{ payment.referenceNumber }}</h2>
        <button class="modal-close" (click)="close()"><i class="fas fa-times"></i></button>
      </div>

      <div class="modal-body">
        <div class="detail-grid">
          <div class="detail-item"><span class="detail-label">Status</span>
            <span class="detail-value"><span [class]="statusClass(payment.status)">{{ payment.status }}</span></span>
          </div>
          <div class="detail-item"><span class="detail-label">Student</span><span class="detail-value">{{ payment.student.fullName || '—' }}</span></div>
          <div class="detail-item"><span class="detail-label">Benefit</span><span class="detail-value">{{ payment.benefitName }}</span></div>
          <div class="detail-item"><span class="detail-label">Payee</span><span class="detail-value">{{ payment.payeeName || '—' }}</span></div>
          <div class="detail-item"><span class="detail-label">Due date</span><span class="detail-value">{{ payment.dueDate | date: 'mediumDate' }}</span></div>
          <div class="detail-item"><span class="detail-label">Amount</span>
            <span class="detail-value">{{ payment.amount | number: '1.2-2' }} {{ payment.currency }}</span>
          </div>
        </div>

        @if (canSettle(payment)) {
          <h3 class="section-heading">Settle this payment</h3>
          <form [formGroup]="settleForm" class="form-grid">
            <label>
              Paid amount
              <input type="number" step="0.01" formControlName="paidAmount" />
            </label>
            <label>
              Payment reference
              <input type="text" formControlName="paymentReference" />
            </label>
            <label>
              Paid date
              <input type="date" formControlName="paidDate" />
            </label>
            <label>
              Notes
              <input type="text" formControlName="notes" />
            </label>
          </form>
        } @else {
          <p class="detail-note">
            @if (payment.paymentReference) { Reference: {{ payment.paymentReference }} · }
            @if (payment.paidDate) { Settled {{ payment.paidDate | date: 'mediumDate' }} }
          </p>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
        @if (canSettle(payment) && authorization.hasPermission(permissions.ClaimPay)) {
          <button type="button" class="btn btn-primary" (click)="settle()" [disabled]="busy()">
            {{ busy() ? 'Saving…' : 'Mark as paid' }}
          </button>
        }
      </div>
    </div>
  </div>
}

                  }
                } @else {
                  <button type="button" class="btn btn-secondary btn-sm" (click)="open(payment)">View</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
